import { use_slice_collections, use_slice_ui, use_slice_workspace } from '@/hooks/store/use_slices';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { DTO__database_entity } from '@shared/dto/_database_entity/DTO__database_entity';
import { DTO__collection } from '@shared/dto/collection/DTO__collection';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { C_LIST_ITEM__collection_master } from './C_LIST_ITEM__collection_master';

interface Props {}

export function C_LIST__collection({}: Props) {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_GENERATION);

  const { workspace_current } = use_slice_workspace(['workspace_current']);
  const { page_collections_hide_unused } = use_slice_ui(['page_collections_hide_unused']);
  const { collection_current, collections_map } = use_slice_collections(['collection_current', 'collections_map']);

  const collection_items = useMemo(() => Array.from(collections_map.values()), [collections_map]);

  /*
   * EFFECTS
   */

  /*
   * METHODS
   */
  function need_show_item(item: DTO__collection) {
    let out = true;

    if (workspace_current._id != item.workspace_id) {
      out = false;
    } else if (item._id == collection_current._id) {
      out = true;
    } else if (page_collections_hide_unused) {
      out = !item.is_hidden;
    }

    return out;
  }

  /*
   * RENDERS
   */
  function render_items() {
    let items_filtered = collection_items.filter(item => !CONSTANTS__shared.WORKSPACE_SPECIAL_COLLECTION_TYPES.includes(item.type));
    items_filtered = items_filtered.filter(need_show_item);

    items_filtered.sort(DTO__database_entity.sort_by_created_at_newest_first);

    let out = items_filtered.map(item => <C_LIST_ITEM__collection_master key={item._id} {...{ item }} />);

    return out;
  }

  /*
   * HTML
   */

  return <div className="flex flex-1 flex-col gap-0  overflow-y-auto bg-component pt-2">{render_items()}</div>;
}
